import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioButton, RadioButtonType } from '@components/atoms/RadioButton';
import { Typography } from '@components/atoms/Typography';
import { IconAccordion } from '@components/molecules/IconAccordion';
import { useData } from '@hooks/useData';

interface AtStorePickupProps {
    selectedAtStorePickup: boolean;
    handleOnSelectAtStorePickup: () => void;
}

const AtStorePickup: FC<AtStorePickupProps> = ({ selectedAtStorePickup, handleOnSelectAtStorePickup }) => {
    const { cart } = useData();
    const { t } = useTranslation();

    const translations = {
        description: t('delivery-address-component.store.explain'),
    };

    useEffect(() => {
        if (cart?.data?.delivery?.pickupAtStore === true) {
            handleOnSelectAtStorePickup();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.data?.delivery?.pickupAtStore]);

    return (
        <IconAccordion.IndentedContent>
            <div className="d-flex align-items-center mb-4">
                <div className="me-4">
                    <RadioButton
                        id="at-store-pickup"
                        name="at-store-pickup"
                        value="at-store-pickup"
                        type={RadioButtonType.normal}
                        checked={selectedAtStorePickup}
                        onChange={(value) => value === 'at-store-pickup' && handleOnSelectAtStorePickup()}
                    />
                </div>
                <div>
                    <Typography classes="mb-1" fontSize="14">
                        {translations.description}
                    </Typography>
                </div>
            </div>
            {/* list of all the stores where the packages will be */}
            <div className="row">
                {cart?.data?.merchantsAddresses?.map((merchant, index) => (
                    <div key={`at-store-pickup-${index}`} className="col-md-6 col-12 mb-3">
                        <Typography classes="mb-1" fontWeight="900">
                            {merchant.commercial_name || ''}
                        </Typography>
                        <Typography classes="mb-1" fontSize="14">
                            {merchant.street}
                        </Typography>
                        <Typography classes="mb-0" fontSize="14">
                            {`${merchant.postal_code} ${merchant.city}`}
                        </Typography>
                    </div>
                ))}
            </div>
        </IconAccordion.IndentedContent>
    );
};

export default AtStorePickup;
